import ApiService from '../apiservice'

export default class TipoAndamentoProcesualService extends ApiService {
  constructor() {
    super('/tipoAndamento');
  }

  cadastrar(tipo) {
    return this.post('/',tipo);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(tipo) {
    return this.put(`/${tipo.codigo}`, tipo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}
